// extracted by mini-css-extract-plugin
export default {"container":"N1-z"};